import { render } from "./TablesTable.vue?vue&type=template&id=2d8f1462"
import script from "./TablesTable.vue?vue&type=script&lang=js"
export * from "./TablesTable.vue?vue&type=script&lang=js"

import exportComponent from "/builds/tel/jcr/ungerboeck_tables/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__